var set = require('regenerate')(0x23, 0x2A, 0x200D, 0x20E3, 0xFE0F);

set.addRange(0x30, 0x39).addRange(0x1F1E6, 0x1F1FF).addRange(0x1F3FB, 0x1F3FF).addRange(0x1F9B0, 0x1F9B3).addRange(0xE0020, 0xE007F);
module.exports = set;